/* useMutationObservable - хук, который используется для создания observer'а,
который следит за изменениями(мутациями) в targetEl(Node). Если в targetEl(Node) произошли изменения(мутации),
то запускается функция cb, в которой мы выполняем какие-либо действия на основании
изменений(мутаций) данных в targetEl(Node). options - это параметр, передаваемый в
observer, который определяет, какой тип изменений(мутаций) отслеживать в targetEl(Node)*/

import { useEffect, useState } from "react";

const DEFAULT_OPTIONS = {
  config: {
    characterData: true, // данная опция позволяет отслеживать изменение(мутацию)
    // значения текстового содержимого целевого узла
    subtree: true /* данная опция позволяет отслеживать изменения(мутации)
    не только целевого элемента, но потомков целевого элемента*/
  },
};

interface UseMutationObservableParams {
  targetEl: Node;
  cb: (mutationList) => void;
  options?: {
    config: MutationObserverInit;
  };
}

export const useMutationObservable = ({ targetEl, cb, options = DEFAULT_OPTIONS }: UseMutationObservableParams) => {
  const [observer, setObserver] = useState<MutationObserver>(null);

  useEffect(() => {
    if (!cb) return;
    const obs = new MutationObserver(cb);
    setObserver(obs);

  }, [cb, options, setObserver]);

  useEffect(() => {
    if (!observer || !targetEl) return;
    const { config } = options;
    observer.observe(targetEl, config);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, targetEl, options]);
}
